import React from 'react';
import { SEMAFORO_CONFIG, getSemaforoLevel } from '../lib/criteria';

// #SemaforoFromPercentage — el backend setea evaluation.semaforo='critico'
// al crear la eval (cuando score=0/percentage=0). Cuando el usuario va
// llenando criterios, en algunos endpoints `percentage` se recalcula
// pero `semaforo` puede quedar atascado en 'critico'. Resultado visible:
// una eval con 100% mostrando badge rojo "CRÍTICO (100.0%)" en lugar
// de verde "BAJO (100.0%)". Fix: si recibimos `percentage`, recomputar
// el nivel del semáforo en el frontend (función pura getSemaforoLevel
// que usa los mismos thresholds que el backend ≤40/60/80). Si no hay
// percentage, fallback al `semaforo` recibido del backend.
export default function SemaforoBadge({ semaforo, percentage, size = 'md' }) {
  // Derivar de percentage si está disponible; el campo `semaforo` puede
  // estar desactualizado en evals que aún no han sido publicadas.
  // #Fase1-4 — Ausencia de calificación nunca se representa como cero crítico.
  if (semaforo === 'sin_calificacion' || percentage === null)
    return (
      <span className="inline-flex rounded-full bg-slate-100 text-slate-600 text-xs px-3 py-1">
        Sin calificación
      </span>
    );
  let cfg;
  if (typeof percentage === 'number' && !isNaN(percentage)) {
    cfg = getSemaforoLevel(percentage);
  } else {
    cfg = SEMAFORO_CONFIG[semaforo] || SEMAFORO_CONFIG.critico;
  }
  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-xs',
    lg: 'px-4 py-2 text-sm font-bold',
  };
  return (
    <span
      data-testid="semaforo-badge"
      className={`inline-flex items-center gap-1.5 rounded-full font-bold uppercase tracking-wide ${cfg.bg} ${cfg.text} ${sizes[size]}`}
    >
      <span className="w-2 h-2 rounded-full bg-white/70 inline-block" />
      {cfg.label}
      {typeof percentage === 'number' && (
        <span className="ml-1 opacity-80">({percentage?.toFixed(1)}%)</span>
      )}
    </span>
  );
}
